import AsyncLoader from 'component/AsyncLoader';

export const SubsidiaryManage =  AsyncLoader(() => import('./SubsidiaryManage'));